import React from "react";
import InputText from "../../../common/Input/InputText";
import styles from "../editLabReport.module.scss";

const sectionConfig = {
  "PHYSICAL EXAMINATION": [
    "Time Of Collection",
    "Time Of Liquefaction",
    "Abstinance",
    "Quantity",
    "Colour",
    "Viscosity",
    "Reaction",
  ],
  "MICROSCOPIC DESCRIPTION": [
    "Total Sperm Count",
    "Actively Motile",
    "Sluggishly Motile",
    "Non Motile",
  ],
  MORPHOLOGY: ["Normal forms", "Abnormal forms"],
  OTHERS: [
    "pus cells",
    "Epithelial cells",
    "RBCs",
    "Prostatic granules",
    "Spermatogenic Cells",
    "Impression",
  ],
};

const SemenAnalysisProfile = ({ profile, testMap, handleTestProfileChange }) => {

  const renderField = (item, index) => {
    const testData = testMap.get(item._id) || {};
    const testName = item?.testName;

    return (
      <div className={styles.testAndProfileWrapper} key={index}>
        
        <div className={styles["inputWrapper"]}>
          <InputText
            value={testName}
            label="Test Name"
            readOnly={true}
          />
        </div>

        <div className={styles["inputWrapper"]}>
          <InputText
            value={testData.value || ""}
            onChange={(e) =>
              handleTestProfileChange(
                e,
                "value",
                profile._id,
                item._id
              )
            }
            label="Value"
          />
        </div>

      </div>
    );
  };

  return (
    <>
      {Object.keys(sectionConfig).map((section) => {

        const sectionTests = profile?.tests?.filter((test) =>
          sectionConfig[section].includes(test.testName)
        );

        if (!sectionTests?.length) return null;

        return (
          <div key={section}>
            <h4 style={{ marginTop: "20px", fontWeight: "600" }}>
              {section}
            </h4>

            {sectionTests.map((item, index) =>
              renderField(item, index)
            )}
          </div>
        );
      })}
    </>
  );
};

export default SemenAnalysisProfile;